
import { FormularioAsignarColaborador, TablaItemsPorTrabajar } from "../components";
import { LayoutCrearDoc } from "../../layouts";
import { useItemsDisponiblesTrabajo } from "../../../hooks/cache";
import { CargandoMedio, ModalFormulario } from "../../components";
import { BuscadorXTermino } from "../../components/buscadores";
import { useCheckData } from "../../../hooks";
import { BotonesGroup } from "../../components/botones";
import { useModalStore } from "../../../stores";
import { marcarItemsComoCompletado } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";

import Swal from "sweetalert2";



export const ItemsListosParaTrabajar = () => {


    const queryClient = useQueryClient();
    const { modalFormToggle, tipo } = useModalStore();
    const { data, isLoading, chagePage, page, termino, chageTermino } = useItemsDisponiblesTrabajo();
    const { selected, handleSelectAllClickUser, handleClick, isSelected, setSelected } = useCheckData(data || []);



    const handleEntregarItems = async() => {
        const { isConfirmed } = await Swal.fire({
            title: 'Marcar Items Como Completado',
            text: '¿Está seguro de marcar estos items como completado, si aceptas los sacas de este listado.?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, seguro'
        });

        if (!isConfirmed) return;

        const resp = await marcarItemsComoCompletado({ items: selected })
        if( resp ){
            queryClient.invalidateQueries({ queryKey: ['disponibles-trabajo'] });
            setSelected([]);
        }
    }


    const options = [
        { label:'Asignar Items', onClick:() => modalFormToggle(true, 'asignarcolaborador'), icono:'asignar', disabled:(selected?.length < 1) },
        { label:'Completar', onClick: handleEntregarItems, icono:'entregar', disabled:(selected?.length < 1) },
    ];

    
    return (
        
        <LayoutCrearDoc titulo='Listado Items Disponibles' add={false}
            subtitulo={(selected.length > 0)  && `Items seleccionados ${selected.length}`}
        >
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de items listos para prodcución..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="item" playhol="op o producto" />

                <BotonesGroup botonesOpciones={options} />

                <TablaItemsPorTrabajar 
                    data={data || []} 
                    chagePage={chagePage} page={page} 
                    selected={selected} 
                    handleSelectAllClickUser={handleSelectAllClickUser} 
                    handleClick={handleClick} 
                    isSelected={isSelected}
                />
                </>
            }


            {(tipo === 'asignarcolaborador') &&
            <ModalFormulario titulo="Asignar Colaborador" valor={{}} onClose={() => modalFormToggle(false)}>
                <FormularioAsignarColaborador selected={selected} setSelected={setSelected} />
            </ModalFormulario>
            }
        </LayoutCrearDoc>
    )
}
    